import React, { useMemo } from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Column } from "@ant-design/plots";

const HitDayDistributionChart = (props) => {
  const { metrics, params } = props.optionsResults;

  const data = useMemo(() => {
    const days = [];
    for (let day = 1; day <= params.maxDays; day++) {
      days.push({ label: `Bar ${day}`, count: metrics.hitDayDistribution[day] });
    }
    days.push({ label: "Miss", count: metrics.hitDayDistribution.miss });
    return days;
  }, [metrics.hitDayDistribution, params.maxDays]);

  const config = {
    data,
    xField: "label",
    yField: "count",
    label: { position: "top" },
  };

  return (
    <GenericCard
      title="Bar-to-hit distribution"
      maxHeight={500}
      isCardOpenByDefault={false}
      className="table-card"
    >
      <Column {...config} height={350} autoFit={false} />
    </GenericCard>
  );
};

HitDayDistributionChart.propTypes = { optionsResults: PropTypes.object };

export default HitDayDistributionChart;
